import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "mt-2 mb-2 cart-address" }
const _hoisted_2 = { class: "b-dark b-white150 pl-2 pt-2 pb-2 pr-2 cart-order-info display-none-media-1200" }
const _hoisted_3 = { class: "text-raleway-20" }
const _hoisted_4 = { class: "d-flex direction-column j-content-center a-i-start mt-1 bb-solid-white100 mb-2" }
const _hoisted_5 = { class: "text-raleway-14" }
const _hoisted_6 = { class: "mt-2 mb-2 d-flex" }
const _hoisted_7 = {
  type: "button",
  class: "btn btn-default-inactive btn-apply-discount"
}
const _hoisted_8 = { class: "d-flex direction-column j-content-center a-i-start mt-1 bb-solid-white100 mb-2" }
const _hoisted_9 = { class: "w-100 mb-1 text-raleway-13 t-white150 d-flex j-content-s-be" }
const _hoisted_10 = { class: "t-dark" }
const _hoisted_11 = { class: "w-100 mb-1 text-raleway-13 t-white150 d-flex j-content-s-be" }
const _hoisted_12 = { class: "w-100 mb-1 text-raleway-13 t-white150 d-flex j-content-s-be" }
const _hoisted_13 = {
  key: 0,
  class: "w-100 mb-1 text-raleway-13 t-white150 d-flex j-content-s-be"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "display-block-media-1200 cart-order-info" }
const _hoisted_17 = { class: "pl-2 pb-2 pr-2 cart-order-info mt--1" }
const _hoisted_18 = { class: "d-flex direction-column j-content-center a-i-start bb-solid-white100 mb-2" }
const _hoisted_19 = { class: "w-100 mb-1 text-raleway-13 t-white150 d-flex j-content-s-be" }
const _hoisted_20 = { class: "t-dark" }
const _hoisted_21 = { class: "w-100 mb-1 text-raleway-13 t-white150 d-flex j-content-s-be" }
const _hoisted_22 = { class: "w-100 mb-1 text-raleway-13 t-white150 d-flex j-content-s-be" }
const _hoisted_23 = {
  key: 0,
  class: "w-100 mb-1 text-raleway-13 t-white150 d-flex j-content-s-be"
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "text-raleway-20 text-center" }
const _hoisted_27 = { class: "text-raleway-20 text-center" }

import CartDeliveryComponent from "../cartDelivery/cartDeliveryComponent.vue";
import { ICartCars, InitialValueCart } from "@/store/modules/Cart/type";
import CartDiscountComponent from "../cartDiscount/cartDiscount.vue";
import { IStore } from "@/store/types/StoreType";
import { Field, useForm } from "vee-validate";
import { computed, ref } from "vue";
import { useStore } from "vuex";

import ErrorMessageComponent from "@/components/errorMessage/errorMessageView.vue";
import ErrorGlobal from "@/components/errorGlobal/errorGlobalView.vue";
import ModalComponent from "@/components/modal/modalComponent.vue";
import { useFetch } from "@/hook/fetch/fetch";
import { PayTrailPayment } from "./type";
import { useRouter } from "vue-router";
import { changeComponentAuthorization } from "@/utils/component/component";


export default /*#__PURE__*/_defineComponent({
  __name: 'cartOrder',
  setup(__props) {

const store = useStore<IStore>();
const customerType = ref(
  computed<string>(() => store.getters.getUserCustomerTypeData)
);
const initialValues = ref<InitialValueCart>(
  store.getters?.getInitinalValueCart
);
const cart = ref(computed<ICartCars[]>(() => store.getters.getCartAll));
const { values, validate } = useForm<InitialValueCart>({
  initialValues: initialValues,
  validationSchema: {},
});

const router = useRouter();

const modal = ref({
  modal: false,
  number: "",
  numberId: "",
});

const errorPage = ref({
  modal: false,
  message: "",
  status: null,
});

const load = ref(false);
const openModal = () => (modal.value.modal = true);
const closeModal = () => (modal.value.modal = false);
const redirectToLogin = () => {
  toAuth();
  changeComponentAuthorization("login_component");
};
const redirectToRegistration = () => {
  toAuth();
  store.commit("setRedirectPath", "cart");
  changeComponentAuthorization("create_account");
};

const toAuth = () => router.push({ path: "auth", replace: true });

const chageErroPage = () => {
  errorPage.value.modal = false;
  store.dispatch("getShoppingCart");
};
const token = ref(computed<string>(() => store.getters.accessTokenGet));
const close = async () => {
  errorPage.value.modal = false;
  const { data, isError, errorMessage } = await useFetch<PayTrailPayment, any>(
    process.env.VUE_APP_SERVER +
      "api/orders/" +
      modal.value.numberId +
      "/payment/",
    "POST",
    true
  );
  if ((isError.value && !data.value) || !data.value?.href) {
    modal.value.modal = false;
    errorPage.value.message = errorMessage.value.error;
    return (errorPage.value.modal = true);
  }
  modal.value.modal = false;
  modal.value.number = "";
  window.location.href = data.value.href;
};
const redirect = () => router.push({ path: "orders", replace: true });
const submitForm = () => {
  if (!load.value) {
    load.value = true;
    errorPage.value.modal = false;
    validate()
      .then(async (e) => {
        if (!e.valid || cart.value.length <= 0) return false;

        store
          .dispatch("createNewOrders", values)
          .then(async (returnData) => {
            modal.value.modal = true;
            modal.value.number = returnData?.order_nav;
            modal.value.numberId = returnData?.id;
            store.commit("dropAllCartBeforeCreate");
          })
          .catch((error) => {
            if (error?.status === 409) {
              errorPage.value.message = error.message?.detail || error.message;
              errorPage.value.modal = true;
              errorPage.value.status = error.status;
              return;
            }
            if (error.message?.detail)
              store.commit("setPopupAccount", {
                open: true,
                message: [
                  {
                    Create: [error.message?.detail],
                  },
                ],
              });
            else if (error.message?.non_field_errors)
              store.commit("setPopupAccount", {
                open: true,
                message: [
                  {
                    Create: [error.message?.non_field_errors],
                  },
                ],
              });
            else
              store.commit("setPopupAccount", {
                open: true,
                message: [
                  {
                    Create: error.message,
                  },
                ],
              });
          })
          .finally(() => {
            load.value = false;
          });
      })
      .catch(() => {
        load.value = false;
      });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "cart-order w-100",
    onSubmit: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(validate)()), ["prevent"]))
  }, [
    _createVNode(CartDiscountComponent, {
      class: _normalizeClass('display-block-media-1200')
    }),
    _createVNode(CartDeliveryComponent, {
      class: _normalizeClass('display-block-media-1200')
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(Field), {
        type: "text",
        class: "w-100 bg-status-gray50 input input-address",
        value: initialValues.value?.address || '',
        name: 'address',
        placeholder: "Address"
      }, null, 8, ["value"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$tc("You order")), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$tc("Discount code")), 1),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_unref(Field), {
            type: "text",
            class: "w-100 bg-status-gray50 input input-discount mr-1",
            placeholder: "Add discount code",
            disabled: "",
            name: 'discount'
          }),
          _createElementVNode("button", _hoisted_7, _toDisplayString(_ctx.$tc("Apply")), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", _hoisted_9, [
          _createTextVNode(_toDisplayString(_ctx.$tc("Subtotal")) + " ", 1),
          _createElementVNode("span", _hoisted_10, _toDisplayString(Number(_unref(store).getters.getAllPriceCurrentPrice).toFixed(2) || 0), 1)
        ]),
        _createElementVNode("span", _hoisted_11, [
          _createTextVNode(_toDisplayString("(" + _ctx.$tc("Discount")) + " ", 1),
          _createElementVNode("span", null, _toDisplayString(Number(_unref(store).getters.getDiscountCart || 0).toFixed(2) + " )"), 1)
        ]),
        _createElementVNode("span", _hoisted_12, [
          _createTextVNode(_toDisplayString(_ctx.$tc("VAT")) + " ", 1),
          _createElementVNode("span", null, _toDisplayString(Number(
              +_unref(store).getters.getAllPriceCurrentPriceVat -
                +_unref(store).getters.getAllPriceCurrentPrice
            ).toFixed(2)), 1)
        ])
      ]),
      (
          Number(_unref(store).getters.getAllPriceCurrentPriceVat).toFixed(2) !==
          Number(_unref(store).getters.getAllPriceCurrentPrice).toFixed(2)
        )
        ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
            _createTextVNode(_toDisplayString(_ctx.$tc("Total inc. VAT")) + " ", 1),
            _createElementVNode("span", null, _toDisplayString(Number(_unref(store).getters.getAllPriceCurrentPriceVat).toFixed(2)), 1)
          ]))
        : _createCommentVNode("", true),
      (token.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: _withModifiers(submitForm, ["stop"]),
            class: _normalizeClass(["btn btn-default-inactive btn-order no-select mt-2", {
          'bg-red100': cart.value.length > 0,
          'bg-white50 not-allowed': cart.value.length <= 0,
        }]),
            type: "submit"
          }, _toDisplayString(load.value ? _ctx.$tc("Loading ...") : _ctx.$tc("Make order")), 11, _hoisted_14))
        : _createCommentVNode("", true),
      (!token.value)
        ? (_openBlock(), _createElementBlock("section", {
            key: 2,
            class: "btn btn-default-inactive btn-order bg-red100 text-decoration-none no-select",
            onClick: _withModifiers(openModal, ["stop"])
          }, _toDisplayString(load.value ? _ctx.$tc("Loading ...") : _ctx.$tc("Make order")), 9, _hoisted_15))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("span", _hoisted_19, [
            _createTextVNode(_toDisplayString(_ctx.$tc("Subtotal")) + " ", 1),
            _createElementVNode("span", _hoisted_20, _toDisplayString(Number(_unref(store).getters.getAllPriceCurrentPrice).toFixed(2) || 0), 1)
          ]),
          _createElementVNode("span", _hoisted_21, [
            _createTextVNode(_toDisplayString("(" + _ctx.$tc("Discount")) + " ", 1),
            _createElementVNode("span", null, _toDisplayString(Number(_unref(store).getters.getDiscountCart || 0).toFixed(2) + " )"), 1)
          ]),
          _createElementVNode("span", _hoisted_22, [
            _createTextVNode(_toDisplayString(_ctx.$tc("VAT")) + " ", 1),
            _createElementVNode("span", null, _toDisplayString(Number(
                +_unref(store).getters.getAllPriceCurrentPriceVat -
                  +_unref(store).getters.getAllPriceCurrentPrice
              ).toFixed(2)), 1)
          ])
        ]),
        (
            Number(_unref(store).getters.getAllPriceCurrentPriceVat).toFixed(2) !==
            Number(_unref(store).getters.getAllPriceCurrentPrice).toFixed(2)
          )
          ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
              _createTextVNode(_toDisplayString(_ctx.$tc("Total inc. VAT")) + " ", 1),
              _createElementVNode("span", null, _toDisplayString(Number(_unref(store).getters.getAllPriceCurrentPriceVat).toFixed(2) || 0), 1)
            ]))
          : _createCommentVNode("", true),
        (token.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              onClick: _withModifiers(submitForm, ["stop"]),
              class: _normalizeClass(["btn btn-default-inactive btn-order no-select mt-2", {
            'bg-red100': cart.value.length > 0,
            'bg-white50 not-allowed': cart.value.length <= 0,
          }]),
              type: "submit"
            }, _toDisplayString(load.value ? _ctx.$tc("Loading ...") : _ctx.$tc("Make order")), 11, _hoisted_24))
          : _createCommentVNode("", true),
        (!token.value)
          ? (_openBlock(), _createElementBlock("section", {
              key: 2,
              class: "btn btn-default-inactive btn-order bg-red100 text-decoration-none no-select",
              onClick: _withModifiers(openModal, ["stop"])
            }, _toDisplayString(load.value ? _ctx.$tc("Loading ...") : _ctx.$tc("Make order")), 9, _hoisted_25))
          : _createCommentVNode("", true)
      ])
    ]),
    (modal.value.modal && customerType.value === 'Private' && token.value)
      ? (_openBlock(), _createBlock(ModalComponent, {
          key: 0,
          title: `Order saved successfully`,
          button_1: 'Pay',
          callback1: close
        }))
      : _createCommentVNode("", true),
    (modal.value.modal && customerType.value !== 'Private' && token.value)
      ? (_openBlock(), _createBlock(ModalComponent, {
          key: 1,
          title: `Order ${modal.value.number} saved successfully`,
          button_1: 'Close',
          callback1: redirect
        }, null, 8, ["title"]))
      : _createCommentVNode("", true),
    (modal.value.modal && customerType.value !== 'Private' && !token.value)
      ? (_openBlock(), _createBlock(ModalComponent, {
          key: 2,
          title: 'To make an order please log in or create new account',
          button_1: 'Log in',
          callback1: redirectToLogin,
          button_2: 'Create new account',
          callback2: redirectToRegistration,
          callback3: closeModal
        }))
      : _createCommentVNode("", true),
    (errorPage.value.modal && errorPage.value.status !== 409)
      ? (_openBlock(), _createBlock(ErrorGlobal, {
          key: 3,
          error: errorPage.value.modal,
          "change-error": chageErroPage
        }, {
          default: _withCtx(() => [
            _createVNode(ErrorMessageComponent, null, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_26, _toDisplayString(errorPage.value.message), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["error"]))
      : (errorPage.value.modal && errorPage.value.status === 409)
        ? (_openBlock(), _createBlock(ErrorGlobal, {
            key: 4,
            error: errorPage.value.modal,
            "change-error": submitForm,
            "change-error2": chageErroPage
          }, {
            default: _withCtx(() => [
              _createVNode(ErrorMessageComponent, null, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_27, _toDisplayString(errorPage.value.message), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["error"]))
        : _createCommentVNode("", true)
  ], 32))
}
}

})